import { environment } from '../../../../environments/environment'

const envName = environment.envName

export const isIntegrationEnviroment = () => (envName !== 'INT' ? false : true)
export const isProductionEnviroment = () => (envName !== 'PROD' ? false : true)

export const isDevelopmentEnviroment = () => (envName !== 'DEV' ? false : true)
